import React, { useEffect } from 'react'

export default function ChatGapify() {
  
  useEffect(() => {
    const BASE_URL = "https://app.gapify.ai";
    const script = document.createElement("script");
    script.src = `${BASE_URL}/packs/js/sdk.js`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
        if (window.gapifySDK) {
            window.gapifySDK.run({
                websiteToken: 'quSMnQtzz3T3GqNGGbxeR6cy',
                baseUrl: BASE_URL,
            });
        }
    };

    document.head.appendChild(script);

    return () => {
        document.head.removeChild(script);
    };
}, []);

  return (
    <></>
  )
}
